module.exports = __webpack_public_path__ + "static/img/space-suit.dfffe61.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/space-suit.jpeg
// module id = RjnA
// module chunks = 0